/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface Domains
 */
export interface Domains {
}

/**
 * Check if a given object implements the Domains interface.
 */
export function instanceOfDomains(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DomainsFromJSON(json: any): Domains {
    return DomainsFromJSONTyped(json, false);
}

export function DomainsFromJSONTyped(json: any, ignoreDiscriminator: boolean): Domains {
    return json;
}

export function DomainsToJSON(value?: Domains | null): any {
    return value;
}

